(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-defence"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      /* Measuring the header's real height/position right away (the
         old code did this synchronously in connectedCallback, via a
         single one-shot IntersectionObserver) can catch it before the
         page has actually settled — the logo image, webfonts, the
         Live Chat button and icon row can all still be laying out.
         That produced a too-small headerBounds.bottom, which made
         onScroll() think you'd already scrolled past the header after
         only a tiny scroll near the top of the page, hiding it (via
         transform) before the page content below had genuinely
         scrolled up to fill that space — showing a blank gap where
         the header used to sit. This is the same class of timing bug
         already fixed elsewhere on this theme for the filter sidebar.
         Wait for the full page load plus two animation frames before
         taking the real measurement (until then, onScroll() simply
         does nothing, since headerBounds.bottom/.top are undefined —
         safe, it just leaves the header in its default state), and
         re-measure on resize since wrapping/logo size can change the
         header's real height later too. */
      this.measureWhenReady();

      /* Re-measuring on resize turned out to be exactly what broke
         the SECOND scroll-down cycle: on mobile, scrolling itself
         fires 'resize' events as the browser's address bar collapses
         and expands (a real, common quirk — nothing to do with the
         header's own width/height changing), and scrolling down then
         back up then down again is precisely the sequence that
         triggers one of those while the header is still mid-hide
         (translateY(-100%) applied). Re-running createObserver() at
         that instant measured the header's CURRENT, off-screen,
         near-zero intersecting rect instead of its true full height —
         corrupting headerBounds for every scroll cycle after that,
         reproducing the original blank-gap bug on the next scroll
         down. Two guards now protect the real measurement: skip
         resize events that only changed the viewport height (the
         address-bar-toggle signature, not a real header-affecting
         resize), and never measure while the header is currently
         hidden — genuine resizes still get picked up on whichever
         later resize event lands while the header is visible. */
      this.lastResizeWidth = window.innerWidth;
      this.onResizeHandler = () => {
        var width = window.innerWidth;
        if (width === this.lastResizeWidth) return;
        this.lastResizeWidth = width;
        if (this.header.classList.contains('shopify-section-header-hidden')) return;
        this.createObserver();
      };
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    measureWhenReady() {
      const measure = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.createObserver());
        });
      };
      if (document.readyState === 'complete') {
        measure();
      } else {
        window.addEventListener('load', measure);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

// Hover mega menu
  //
  // Guarded against a real race condition: on a completely cold page
  // load (a brand-new tab, no cached assets yet), this script can
  // finish downloading and start running AFTER 'DOMContentLoaded' has
  // already fired. Registering a listener for an event that already
  // happened is a no-op forever, so the hover menu would never get
  // wired up for that page view — while a refresh, with this script
  // now cached, loads it fast enough to reliably beat the event and
  // works fine. Checking document.readyState first and running
  // immediately if the DOM is already parsed closes that gap: hover
  // now initialises correctly whichever order things arrive in.
  const initHoverMegaMenu = () => {
    const menuItems = document.querySelectorAll('.header__inline-menu details-disclosure');
    let closeTimer = null;

    const cancelClose = () => clearTimeout(closeTimer);

    // Re-centers a mega menu panel on the true browser viewport, not on
    // whatever element happens to be its CSS containing block. The panel
    // is position: absolute (so it correctly tracks the header through
    // scroll/hide/reveal), but that means its "left: 50%" is measured
    // from its containing block's own box, which turns out to be a
    // narrower, off-centre ancestor inside the header (not the
    // full-width header-wrapper), pulling the panel off true
    // page-centre. Measuring the containing block's actual on-screen
    // position via offsetParent and computing where the middle of the
    // viewport falls relative to it fixes this regardless of which
    // ancestor ends up being the containing block.
    const centerMegaMenu = (megaMenu) => {
      if (!megaMenu || megaMenu.classList.contains('custom-mega-menu--centered-self')) return;
      const parent = megaMenu.offsetParent;
      if (!parent) return;
      const parentRect = parent.getBoundingClientRect();
      const viewportCenter = window.innerWidth / 2;
      megaMenu.style.left = (viewportCenter - parentRect.left) + 'px';
    };

    // The centering above is only as good as the layout that exists the
    // instant it runs. On a completely fresh page load (as opposed to
    // clicking through from another page, where fonts/images/apps are
    // already warm in the browser cache) something can still shift the
    // header's box a few pixels AFTER a menu has already opened and been
    // centred once — a webfont swapping in, an announcement bar or app
    // widget finishing its own late render, an image settling. Rather
    // than guess at which one it is on this specific site, watch the
    // actual containing block for size changes and re-run the centering
    // automatically whenever it moves/resizes while a menu is open, and
    // double-check once webfonts finish loading. This makes the panel
    // self-correcting regardless of what caused the late shift.
    let currentOpenMegaMenu = null;
    let megaMenuResizeObserver = null;
    const watchMegaMenuParent = (megaMenu) => {
      if (!('ResizeObserver' in window)) return;
      if (!megaMenuResizeObserver) {
        megaMenuResizeObserver = new ResizeObserver(() => {
          if (currentOpenMegaMenu) centerMegaMenu(currentOpenMegaMenu);
        });
      }
      megaMenuResizeObserver.disconnect();
      const parent = megaMenu.offsetParent;
      if (parent) megaMenuResizeObserver.observe(parent);
    };
    const stopWatchingMegaMenuParent = () => {
      currentOpenMegaMenu = null;
      if (megaMenuResizeObserver) megaMenuResizeObserver.disconnect();
    };
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (currentOpenMegaMenu) centerMegaMenu(currentOpenMegaMenu);
      });
    }

    const triggerClose = (details, megaMenu) => {
      closeTimer = setTimeout(() => {
        if (megaMenu) {
          megaMenu.style.opacity = '0';
          setTimeout(() => details.removeAttribute('open'), 200);
        } else {
          details.removeAttribute('open');
        }
      }, 80);
    };

    menuItems.forEach(disclosure => {
      const details = disclosure.querySelector('details');
      if (!details) return;
      const megaMenu = details.querySelector('.custom-mega-menu');

      disclosure.addEventListener('mouseenter', () => {
        cancelClose();
        document.querySelectorAll('.header__inline-menu details[open]').forEach(d => {
          if (d !== details) {
            d.removeAttribute('open');
            const otherMenu = d.querySelector('.custom-mega-menu');
            if (otherMenu) otherMenu.style.opacity = '0';
          }
        });
        details.setAttribute('open', '');
        if (megaMenu) {
          centerMegaMenu(megaMenu);
          currentOpenMegaMenu = megaMenu;
          watchMegaMenuParent(megaMenu);
          requestAnimationFrame(() => { megaMenu.style.opacity = '1'; });
        }
      });

      disclosure.addEventListener('mouseleave', (e) => {
        if (!megaMenu) {
          triggerClose(details, null);
          return;
        }
        const menuRect = megaMenu.getBoundingClientRect();
        const movingIntoMenu = e.clientX >= menuRect.left && e.clientX <= menuRect.right &&
                               e.clientY >= menuRect.top && e.clientY <= menuRect.bottom + 5;
        if (!movingIntoMenu) {
          triggerClose(details, megaMenu);
          stopWatchingMegaMenuParent();
        }
      });

      if (megaMenu) {
        megaMenu.addEventListener('mouseenter', cancelClose);
        megaMenu.addEventListener('mouseleave', (e) => {
          const headerRect = document.querySelector('.header-wrapper').getBoundingClientRect();
          const movingIntoHeader = e.clientX >= headerRect.left && e.clientX <= headerRect.right &&
                                   e.clientY >= headerRect.top && e.clientY <= headerRect.bottom;
          if (!movingIntoHeader) {
            triggerClose(details, megaMenu);
            stopWatchingMegaMenuParent();
          }
        });
      }
    });

    // Keep the open mega menu correctly centred if the window is resized
    // while it's showing (e.g. rotating a tablet, or resizing a browser
    // window) rather than leaving it pinned to a now-stale offset.
    window.addEventListener('resize', () => {
      const openDetails = document.querySelector('.header__inline-menu details[open]');
      if (!openDetails) return;
      centerMegaMenu(openDetails.querySelector('.custom-mega-menu'));
    }, { passive: true });

    // Close any open mega menu the instant the page scrolls. Combined
    // with the position: absolute tracking above, this is a safety net
    // that means the panel is never seen partway through re-tracking a
    // scroll-in-progress — it simply disappears at the first pixel of
    // scroll and reopens fresh, correctly positioned, next time you
    // hover a heading.
    window.addEventListener('scroll', () => {
      const openDetails = document.querySelector('.header__inline-menu details[open]');
      if (!openDetails) return;
      clearTimeout(closeTimer);
      const megaMenu = openDetails.querySelector('.custom-mega-menu');
      stopWatchingMegaMenuParent();
      if (megaMenu) {
        megaMenu.style.opacity = '0';
        setTimeout(() => openDetails.removeAttribute('open'), 200);
      } else {
        openDetails.removeAttribute('open');
      }
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMegaMenu);
  } else {
    initHoverMegaMenu();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
      element.classList.remove('active');
    });

    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');

    const container = this.querySelector('[role="document"]');
    container.scrollTop = 0;
    container.scrollLeft = 0;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-header"] && !Shopify.designMode) return;
  try {
    

    const root = document.documentElement;
const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
const marqueeContent = document.querySelector("ul.marquee-content");

root.style.setProperty("--marquee-elements", marqueeContent.children.length);

for(let i=0; i<marqueeElementsDisplayed; i++) {
  marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
}
  

  } catch(e) { console.error(e); }
})();
})();
